module.exports = __webpack_public_path__ + "static/second-57fecdc8570cefb88e472cd532bf0b82.png";